// extracted by mini-css-extract-plugin
export var component = "ImageParagraph-module--component--a3cc1";
export var creditLabel = "ImageParagraph-module--creditLabel--a5c0a";
export var fadePop = "ImageParagraph-module--fade-pop--aa052";
export var growHeightIn = "ImageParagraph-module--grow-height-in--28404";
export var imageWrapper = "ImageParagraph-module--imageWrapper--e538b";
export var noCredit = "ImageParagraph-module--noCredit--32270";